<template>
  <span>
    <crud-layout-search
      ref="crudLayoutSearch"
      :params="params"
      :interface="nmInterface"
      :id="id"
      :row-buttons="true"
      :page="page"
      multiselect
      :name="name"
    >
      <template-page-table
        slot="page-table"
        slot-scope="dataPageTable"
        v-bind="dataPageTable"
        @action-button="dataPageTable.actionButton"
        @show-message="dataPageTable.showMessage"
      />
    </crud-layout-search>

    <template-modal
      ref="templateModal"
      :show.sync="showTemplateModal"
      :get-purpose-icon="getPurposeIcon"
      :get-variable-color-scheme="getVariableColorScheme"
      :purpose-types="purposeTypes"
      @template-saved="onTemplateSaved"
    />

    <template-detail-modal
      ref="detailModal"
      :show.sync="showDetailModal"
      :get-purpose-icon="getPurposeIcon"
      :purpose-types="purposeTypes"
      @edit-template="onDetailEditTemplate"
    />
  </span>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import TemplateEditModal from './TemplateEditModal.vue'
import TemplateDetailModal from './TemplateDetailModal.vue'
import TemplatePageTable from './TemplatePageTable.vue'
import { messagingPurpose } from 'src/shared/inf-tabela-descricao/MessagingPurpose.enum.js'
import { getVariableColorScheme as importedGetVariableColorScheme } from '../utils/variableColorScheme.js'

const { page, pageTable, CrudLayoutSearch } = JtCrud
@Component({
  mixins: [page],
  name: 'Template',
  components: {
    CrudLayoutSearch,
    TemplateModal: TemplateEditModal,
    TemplateDetailModal,
    TemplatePageTable
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class Template extends Vue {
  showTemplateModal = false
  showDetailModal = false

  get nmInterface () {
    return this.interface
  }

  get page () {
    return page
  }

  get purposeTypes () {
    const p = messagingPurpose()
    return {
      ONE_TIME_PAYMENT: p.ONE_TIME_PAYMENT.key,
      INSTALLMENT: p.INSTALLMENT.key,
      REGULAR_INVOICE: p.REGULAR_INVOICE.key,
      NOTICE: p.NOTICE.key,
      ADDITIONAL: p.ADDITIONAL.key
    }
  }

  getPurposeIcon (purposeId) {
    const p = messagingPurpose()
    const icons = {
      [p.ONE_TIME_PAYMENT.key]: 'local_atm',
      [p.INSTALLMENT.key]: 'event',
      [p.REGULAR_INVOICE.key]: 'notifications',
      [p.NOTICE.key]: 'warning',
      [p.ADDITIONAL.key]: 'account_balance'
    }
    return icons[purposeId] || 'description'
  }

  getVariableColorScheme (variableOrTypeId) {
    return importedGetVariableColorScheme(variableOrTypeId)
  }

  async mounted () {
    await this.$nextTick()
    this.$refs.crudLayoutSearch.onButton('btNovo', () => this.openTemplateModal())
    this.$refs.crudLayoutSearch.onButton('icAlterar', (button, params) => this.openEditModal(button, params))
    this.$refs.crudLayoutSearch.onButton('icDetalhar', (button, params) => this.openDetailModal(button, params))
  }

  openTemplateModal () {
    this.$refs.templateModal.openCreate()
  }

  openEditModal (button, params) {
    const row = params || button?.params || button || {}
    const id = row.id || row.template || row.templateId
    if (!id) {
      return
    }
    this.$refs.templateModal.openEdit(id)
  }

  openDetailModal (button, params) {
    const row = params || button?.params || button || {}
    const id = row.id || row.template || row.templateId
    if (!id) {
      return
    }
    this.$refs.detailModal.openDetail(id)
  }

  onTemplateSaved () {
    this.$refs.crudLayoutSearch?.refresh?.()
  }

  onDetailEditTemplate (templateId) {
    this.$refs.templateModal.openEdit(templateId)
  }
}
export default Template
</script>
